import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./parsebulkques.css";
import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
import { fetchCourseData } from "./../../../Redux/StudentRegistration/courseSlice";
import { API_BASE_URL } from "../../../Config/Config";
import FileUpload from "./FileUpload";
import AddOptionDropdwon from "./AddDropdownOptions";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Warning.png";
import SuccessImg from "./../../../Assets/Images/CommanImages/Informative.png";
import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
import DropDownUP from "./Dropdown";
import DropDownUP2 from "./DropdownUP2";

const ParseBulkQuestion = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  pauseTimer,
  resumeTimer,
  setNoTimeSet,
  dataClient,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { coursesdata } = useSelector((state) => state.course);
  const [isOpenTagging, setIsOpenTagging] = useState(true);
  const [isOpenUpload, setIsOpenUpload] = useState(true);
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [chapters, setChapters] = useState([]);
  const [selectedChapter, setSelectedChapter] = useState(null);
  const [topics, setTopics] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [tags, setTags] = useState([]);
  const [dropdownData, setDropdownData] = useState({});
  const [value, setValues] = useState({ course_id: "" });
  const [setNames, setSetNames] = useState([]);
  const [selectedSetName, setSelectedSetName] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [dropdownKey, setDropdownKey] = useState(Date.now());
  const [selectedSubjectLabel, setSelectedSubjectLabel] = useState(""); // Add this line
  const [selectedChapterLabel, setSelectedChapterLabel] = useState("");
  const [selectedTopicLabel, setSelectedTopicLabel] = useState("");
  const [topicId, setTopicId] = useState(null);
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
  const accessToken = localStorage.getItem("other");

  const toggleTaggingAccordion = () => {
    setIsOpenTagging(!isOpenTagging);
  };

  const toggleUploadAccordion = () => {
    setIsOpenUpload(!isOpenUpload);
  };

  useEffect(() => {
    dispatch(fetchCourseData());
    fetchTags();
  }, [dispatch]);

  useEffect(() => {
    const fetchSetNames = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-parse-ques-set-all/`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        if (response.ok) {
          const formattedSetNames = data.data.map((item) => ({
            label: item.parse_ques_set_name,
            id: item.parse_ques_set_id,
          }));
          setSetNames(formattedSetNames);
        } else {
          console.error("Failed to fetch set names:", data.message);
        }
      } catch (error) {
        console.error("Error while fetching set names:", error);
      }
    };
    fetchSetNames();
  }, []);

  const fetchTags = async () => {
    try {
      // const token = sessionStorage.getItem("other");
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-parse-tags-all/`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const data = await response.json();
      if (response.ok) {
        setTags(data.data);
      } else {
        console.error("Error fetching tags:", data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    const fetchSubjects = async () => {
      if (value.course_id) {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subjects-by-course/?course_id=${value.course_id}`
        );
        const data = await response.json();
        setSubjects(data);
        setSelectedSubjectLabel(""); // Reset the subject label
        setSelectedChapterLabel(""); // Reset the chapter label
        setSelectedTopicLabel(""); // Reset the topic label
        setTopicId(null); // Reset the topic ID
      }
    };

    fetchSubjects();
  }, [value.course_id]);

  useEffect(() => {
    const fetchChapters = async () => {
      if (selectedSubject) {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-chapters-by-subject/?subject_id=${selectedSubject}`
        );
        const data = await response.json();
        setChapters(data);
        setSelectedChapterLabel(""); // Reset the chapter label
        setSelectedTopicLabel(""); // Reset the topic label
        setTopicId(null); // Reset the topic ID
      }
    };

    fetchChapters();
  }, [selectedSubject]);

  useEffect(() => {
    const fetchTopics = async () => {
      if (selectedChapter) {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-topics-by-chapter/?chapter_id=${selectedChapter}`
        );
        const data = await response.json();
        setTopics(data);
        setSelectedTopicLabel(""); // Reset the topic label
        setTopicId(null); // Reset the topic ID
      }
    };

    fetchTopics();
  }, [selectedChapter]);

  const handleDropdownChange = (tag, selectedOption) => {
    setDropdownData((prevData) => ({
      ...prevData,
      [tag.parse_tag_id]: selectedOption,
    }));
  };

  const handleFileUpload = (file) => {
    setUploadedFile(file);
  };

  const prepareTags = () => {
    const selectedTags = [];

    // Process dropdown tags
    tags
      .filter((tag) => tag.parse_tag_type === 1)
      .forEach((tag) => {
        const selectedOption = dropdownData[tag.parse_tag_id]; // Get the selected option for this tag
        if (selectedOption) {
          selectedTags.push({
            parse_ques_set_id: null,
            parse_ques_set_question_id: null,
            parse_ques_tag_id: tag.parse_tag_id,
            parse_ques_tag_value_id: selectedOption,
          });
        }
      });

    // Process checkbox tags
    tags
      .filter((tag) => tag.parse_tag_type === 2)
      .forEach((tag) => {
        const checkbox = document.getElementById(
          `checkbox-${tag.parse_tag_id}`
        );
        if (checkbox) {
          selectedTags.push({
            parse_ques_set_id: null,
            parse_ques_set_question_id: null,
            parse_ques_tag_id: tag.parse_tag_id,
            parse_ques_tag_value_id: checkbox.checked ? 1 : 0, // 1 if checked, 0 otherwise
          });
        }
      });

    if (value.course_id) {
      selectedTags.push({
        parse_ques_set_id: null,
        parse_ques_set_question_id: null,
        parse_ques_tag_id: 2,
        parse_ques_tag_value_id: value.course_id,
      });
    }
    if (selectedSubject) {
      selectedTags.push({
        parse_ques_set_id: null,
        parse_ques_set_question_id: null,
        parse_ques_tag_id: 3,
        parse_ques_tag_value_id: selectedSubject,
      });
    }
    if (selectedChapter) {
      selectedTags.push({
        parse_ques_set_id: null,
        parse_ques_set_question_id: null,
        parse_ques_tag_id: 4,
        parse_ques_tag_value_id: selectedChapter,
      });
    }
    if (topicId) {
      selectedTags.push({
        parse_ques_set_id: null,
        parse_ques_set_question_id: null,
        parse_ques_tag_id: 5,
        parse_ques_tag_value_id: topicId,
      });
    }
    return selectedTags;
  };

  // const handleSaveAndTagsInOneClick = async () => {
  //   if (!uploadedFile && !selectedSetName) {
  //     console.error("No file selected!");
  //     setIsMessageBoxVisible(true);
  //     setMessageBox(
  //       <div
  //         className="Container-messageBOX"
  //         onMouseEnter={pauseTimer}
  //         onMouseLeave={resumeTimer}
  //       >
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>No file uploaded and no set name selected. Please upload a file and select a set name before proceeding.</span>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(InterogativeImg);
  //     return;
  //   }

  //   try {
  //     let parseQuesSetId = null;

  //     // Determine if selectedSetName is valida
  //     if (selectedSetName && typeof selectedSetName === "object" && selectedSetName.id) {
  //       parseQuesSetId = selectedSetName.id;
  //     }

  //     const saveEndpoint = `${API_BASE_URL}/coaching-collaborator-api/api/v1/post-parse-question-bulk?parse_ques_set_name=${encodeURIComponent(
  //       typeof selectedSetName === "string" ? selectedSetName : selectedSetName.label
  //     )}&client_id=${clientId}&client_branch_id=${clientBranchId}&parse_ques_set_ques_type=1&username=${userName}${
  //       parseQuesSetId ? `&parse_ques_set_id=${parseQuesSetId}` : ""
  //     }`;

  //     const formData = new FormData();
  //     formData.append("selectedfile", uploadedFile);

  //     const saveResponse = await fetch(saveEndpoint, {
  //       method: "POST",
  //       headers: {
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //       body: formData,
  //     });

  //     const saveData = await saveResponse.json();

  //     // console.log(saveData.result.new_parse_ques_set_id, "saveData");

  //      if (!saveResponse.ok) {
  //       console.error("Error saving file:", saveData);
  //       showErrorMessage(
  //         `Failed to save file: ${saveData.message || "Unknown error"}`,
  //         "save_error.txt",
  //         `Error Details:\n${JSON.stringify(saveData, null, 2)}`
  //       );
  //       return;
  //     }

  //     parseQuesSetId = saveData.result.new_parse_ques_set_id;

  //     const selectedTags = prepareTags();
  //     const tagsEndpoint = `${API_BASE_URL}/coaching-collaborator-api/api/v1/insert-parse-ques-tags/?parse_ques_set_id=${parseQuesSetId}`;

  //     const tagsResponse = await fetch(tagsEndpoint, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //       body: JSON.stringify(selectedTags),
  //     });

  //     const tagsData = await tagsResponse.json();

  //     if (!tagsResponse.ok) {
  //       console.error("Failed to save tags:", tagsData);
  //       showErrorMessage(
  //         `Error saving tags: ${tagsData.message || "Unknown error"}`,
  //         "tags_error.txt",
  //         `Error Details:\n${JSON.stringify(tagsData, null, 2)}`
  //       );
  //       return;
  //     }

  //     setIsMessageBoxVisible(true);
  //     setMessageBox(
  //       <div
  //         className="Container-messageBOX"
  //         onMouseEnter={pauseTimer}
  //         onMouseLeave={resumeTimer}
  //       >
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>Processing the file and saving...</span>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(InterogativeImg);
  //     setTimeout(() => {
  //       setIsMessageBoxVisible(false);
  //       window.location.reload();
  //     }, 5000);
  //   } catch (error) {
  //     console.error("Error during the process:", error);
  //     setIsMessageBoxVisible(true);
  //     setMessageBox(
  //       <div
  //         className="Container-messageBOX"
  //         onMouseEnter={pauseTimer}
  //         onMouseLeave={resumeTimer}
  //       >
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>An unexpected error occurred. Please try again later.</span>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(InterogativeImg);
  //   }
  // };

  // if (!uploadedFile || !selectedSetName) {
  //   console.error("No file selected!");
  //   setIsMessageBoxVisible(true);
  //   setMessageBox(
  //     <div
  //       className="Container-messageBOX"
  //       onMouseEnter={pauseTimer}
  //       onMouseLeave={resumeTimer}
  //     >
  //       <div className="messagebox-insider1">
  //         <div className="loader-tc"></div>
  //         <span>No file uploaded and no set name selected. Please upload a file and select a set name before proceeding.</span>
  //       </div>
  //     </div>
  //   );
  //   setActiveImg(InterogativeImg);
  //   return;
  // }

  // const showErrorMessage = (message, fileName, content) => {
  //   setIsMessageBoxVisible(true);
  //   setMessageBox(
  //     <div className="Container-messageBOX">
  //       <div className="messagebox-insider1">
  //         <div className="loader-tc"></div>
  //         <span>{message}</span>
  //       </div>
  //       <div className="messagebox-insider2">
  //         <button
  //           className="messagebox-cancel-btn"
  //           onClick={() => setIsMessageBoxVisible(false)}
  //         >
  //           OK
  //         </button>
  //         {fileName && content && (
  //           <button
  //             className="messagebox-cancel-btn"
  //             onClick={() => downloadTxtFile(fileName, content)}
  //           >
  //             Download Error
  //           </button>
  //         )}
  //       </div>
  //     </div>
  //   );
  //   setActiveImg(ErrorImg);
  // };

  // const downloadTxtFile = (fileName, content) => {
  //   const blob = new Blob([content], { type: "text/plain" });
  //   const link = document.createElement("a");
  //   link.href = URL.createObjectURL(blob);
  //   link.download = fileName;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  // const handleSaveAndTagsInOneClick = async () => {
  //   if (!uploadedFile || !selectedSetName || !value.course_id) {
  //     console.error("Validation Error!");

  //     let errorMessage = "";
  //     if (!uploadedFile && !selectedSetName && !value.course_id) {
  //       errorMessage = "No file uploaded, no set name selected, and no course selected. Please provide all required inputs.";
  //     } else if (!uploadedFile) {
  //       errorMessage = "No file uploaded. Please upload a file before proceeding.";
  //     } else if (!selectedSetName) {
  //       errorMessage = "No set name selected. Please select a set name before proceeding.";
  //     } else if (!value.course_id) {
  //       errorMessage = "No course selected. Please select a course before proceeding.";
  //     }

  //     setIsMessageBoxVisible(true);
  //     setMessageBox(
  //       <div
  //         className="Container-messageBOX"
  //         onMouseEnter={pauseTimer}
  //         onMouseLeave={resumeTimer}
  //       >
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>{errorMessage}</span>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(InterogativeImg);
  //     return;
  //   }

  //   try {
  //     setIsMessageBoxVisible(true);
  //     setMessageBox(
  //       <div
  //         className="Container-messageBOX"
  //         onMouseEnter={pauseTimer}
  //         onMouseLeave={resumeTimer}
  //       >
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>Processing the file and saving...</span>
  //         </div>
  //       </div>
  //     );

  //     let parseQuesSetId = null;

  //     if (selectedSetName && typeof selectedSetName === "object" && selectedSetName.id) {
  //       parseQuesSetId = selectedSetName.id;
  //     }

  //     const saveEndpoint = `${API_BASE_URL}/coaching-collaborator-api/api/v1/post-parse-question-bulk?parse_ques_set_name=${encodeURIComponent(
  //       typeof selectedSetName === "string" ? selectedSetName : selectedSetName.label
  //     )}&client_id=${clientId}&client_branch_id=${clientBranchId}&parse_ques_set_ques_type=1&username=${userName}${parseQuesSetId ? `&parse_ques_set_id=${parseQuesSetId}` : ""
  //       }`;

  //     const formData = new FormData();
  //     formData.append("selectedfile", uploadedFile);

  //     const saveResponse = await fetch(saveEndpoint, {
  //       method: "POST",
  //       headers: {
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //       body: formData,
  //     });

  //     const saveData = await saveResponse.json();

  //     if (!saveResponse.ok) {
  //       showErrorMessage(
  //         `Failed to save file: ${saveData.message || "Unknown error"}`,
  //         "save_error.txt",
  //         `Error Details:\n${JSON.stringify(saveData, null, 2)}`
  //       );
  //       return;
  //     }

  //     parseQuesSetId = saveData.result.new_parse_ques_set_id;

  //     const selectedTags = prepareTags();
  //     const tagsEndpoint = `${API_BASE_URL}/coaching-collaborator-api/api/v1/insert-parse-ques-tags/?parse_ques_set_id=${parseQuesSetId}`;

  //     const tagsResponse = await fetch(tagsEndpoint, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //       body: JSON.stringify(selectedTags),
  //     });

  //     if (setNames.some((set) => set.id === selectedSetName?.id)) {
  //       setIsMessageBoxVisible(true);
  //       setMessageBox(
  //         <div
  //           className="Container-messageBOX"
  //           onMouseEnter={pauseTimer}
  //           onMouseLeave={resumeTimer}
  //         >
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc"></div>
  //             <span>
  //               Set name already exists with ID: {selectedSetName?.id}.
  //             </span>
  //           </div>
  //         </div>
  //       );
  //       return;
  //     }

  //     const errors = saveData.errors || [];
  //     const successMessage = saveData.result.message || "Operation completed successfully.";

  //     setMessageBox(
  //       <div
  //         className="Container-messageBOX"
  //         onMouseEnter={pauseTimer}
  //         onMouseLeave={resumeTimer}
  //       >
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>{successMessage}</span>
  //         </div>
  //         {errors.length > 0 && (
  //           <div className="messagebox-insider2">
  //             <button
  //               className="messagebox-cancel-btn"
  //               onClick={() =>
  //                 downloadTxtFile("error_report.txt", errors.join("\n"))
  //               }
  //             >
  //               Download Report
  //             </button>
  //           </div>
  //         )}
  //       </div>
  //     );
  //     setActiveImg(errors.length > 0 ? InterogativeImg : SuccessImg);
  //     setTimeout(() => {
  //       window.location.reload();
  //     }, 2000);
  //   } catch (error) {
  //     setMessageBox(
  //       <div
  //         className="Container-messageBOX"
  //         onMouseEnter={pauseTimer}
  //         onMouseLeave={resumeTimer}
  //       >
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>An unexpected error occurred. Please try again later.</span>
  //         </div>
  //         <div className="messagebox-insider2">
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(InterogativeImg);
  //   }
  // };

  const showErrorMessage = (message, fileName, content) => {
    setIsMessageBoxVisible(true);
    setNoTimeSet(true); // Prevent timer-based closure of the message box
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>{message}</span>
        </div>
        <div
          className="messagebox-insider2"
          style={{ display: "flex", gap: "10px" }}
        >
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
              setNoTimeSet(false); // Re-enable timer for other messages
              setTimeout(() => {
                window.location.reload();
              }, 2000);
            }}
          >
            OK
          </button>
          {fileName && content && (
            <button
              className="messagebox-cancel-btn"
              onClick={() => downloadTxtFile(fileName, content)}
              style={{ width: "122px" }}
            >
              Download Report
            </button>
          )}
        </div>
      </div>
    );
    setActiveImg(InterogativeImg);
  };

  const downloadTxtFile = (fileName, content) => {
    const blob = new Blob([content], { type: "text/plain" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

    const handleBulkUpload = async () => {
    // Initial validation
    if (
      !uploadedFile ||
      !selectedSetName ||
      !value.course_id ||
      !selectedSubject
    ) {
      let errorMessage = "";
      if (
        !uploadedFile &&
        !selectedSetName &&
        !value.course_id &&
        !selectedSubject
      ) {
        errorMessage =
          "No file uploaded, no set name selected, and no course selected. Please provide all required inputs.";
      } else if (!uploadedFile) {
        errorMessage =
          "No file uploaded. Please upload a file before proceeding.";
      } else if (!selectedSetName) {
        errorMessage =
          "No set name selected. Please select a set name before proceeding.";
      } else if (!value.course_id) {
        errorMessage =
          "No course selected. Please select a course before proceeding.";
      } else if (!selectedSubject) {
        errorMessage =
          "No subject selected. Please select a subject before proceeding.";
      }
      throw new Error(errorMessage);
    }

    // Check if set name already exists
    if (setNames.some((set) => set.id === selectedSetName?.id)) {
      throw new Error(
        `Set name already exists with ID: ${selectedSetName?.id}.`
      );
    }

    let parseQuesSetId = null;
    if (
      selectedSetName &&
      typeof selectedSetName === "object" &&
      selectedSetName.id
    ) {
      parseQuesSetId = selectedSetName.id;
    }

    // First API call - Save bulk questions
    const saveEndpoint = `${API_BASE_URL}/coaching-collaborator-api/api/v1/post-parse-question-bulk?parse_ques_set_name=${encodeURIComponent(
      typeof selectedSetName === "string"
        ? selectedSetName
        : selectedSetName.label
    )}&client_id=${clientId}&client_branch_id=${clientBranchId}&parse_ques_set_ques_type=1&username=${userName}${
      parseQuesSetId ? `&parse_ques_set_id=${parseQuesSetId}` : ""
    }`;

    const formData = new FormData();
    formData.append("selectedfile", uploadedFile);

    const saveResponse = await fetch(saveEndpoint, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: formData,
    });

    const saveData = await saveResponse.json();

    if (!saveResponse.ok) {
      const errorMsg = saveData.detail || saveData.message || "Unknown error";
      if (errorMsg === "Unknown error") {
        showErrorMessage(
          "An unexpected error occurred. Please download and review the details.",
          "unknown_error.txt",
          `Error Details:\n${JSON.stringify(saveData, null, 2)}`
        );
      }
      throw new Error(errorMsg);
    }

    return saveData;
  };
  // First function - Handle bulk upload
  // const handleBulkUpload = async () => {
  //   // Initial validation
  //   if (
  //     !uploadedFile ||
  //     !selectedSetName ||
  //     !value.course_id ||
  //     !selectedSubject
  //   ) {
  //     let errorMessage = "";
  //     if (
  //       !uploadedFile &&
  //       !selectedSetName &&
  //       !value.course_id &&
  //       !selectedSubject
  //     ) {
  //       errorMessage =
  //         "No file uploaded, no set name selected, and no course selected. Please provide all required inputs.";
  //     } else if (!uploadedFile) {
  //       errorMessage =
  //         "No file uploaded. Please upload a file before proceeding.";
  //     } else if (!selectedSetName) {
  //       errorMessage =
  //         "No set name selected. Please select a set name before proceeding.";
  //     } else if (!value.course_id) {
  //       errorMessage =
  //         "No course selected. Please select a course before proceeding.";
  //     } else if (!selectedSubject) {
  //       errorMessage =
  //         "No subject selected. Please select a subject before proceeding.";
  //     }
  //     throw new Error(errorMessage);
  //   }

  //   // Check if set name already exists
  //   if (setNames.some((set) => set.id === selectedSetName?.id)) {
  //     throw new Error(
  //       `Set name already exists with ID: ${selectedSetName?.id}.`
  //     );
  //   }

  //   let parseQuesSetId = null;
  //   if (
  //     selectedSetName &&
  //     typeof selectedSetName === "object" &&
  //     selectedSetName.id
  //   ) {
  //     parseQuesSetId = selectedSetName.id;
  //   }

  //   // First API call - Save bulk questions
  //   const saveEndpoint = `${API_BASE_URL}/coaching-collaborator-api/api/v1/post-parse-question-bulk?parse_ques_set_name=${encodeURIComponent(
  //     typeof selectedSetName === "string"
  //       ? selectedSetName
  //       : selectedSetName.label
  //   )}&client_id=${clientId}&client_branch_id=${clientBranchId}&parse_ques_set_ques_type=1&username=${userName}${
  //     parseQuesSetId ? `&parse_ques_set_id=${parseQuesSetId}` : ""
  //   }`;

  //   const formData = new FormData();
  //   formData.append("selectedfile", uploadedFile);

  //   const saveResponse = await fetch(saveEndpoint, {
  //     method: "POST",
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`,
  //     },
  //     body: formData,
  //   });

  //   const saveData = await saveResponse.json();

  //   if (!saveResponse.ok) {
  //     throw new Error(saveData.detail || saveData.message || "Unknown error");
  //   }

  //   return saveData;
  // };

  // Second function - Handle tags update
  const handleTagsUpdate = async (parseQuesSetId, saveData) => {
    const selectedTags = prepareTags();
    const tagsEndpoint = `${API_BASE_URL}/coaching-collaborator-api/api/v1/insert-parse-ques-tags/?parse_ques_set_id=${parseQuesSetId}`;

    const tagsResponse = await fetch(tagsEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(selectedTags),
    });

    const tagsData = await tagsResponse.json();

    if (!tagsResponse.ok) {
      throw new Error(tagsData.message || "Unknown error");
    }

    // Handle any errors from bulk save
    const errors = saveData.errors || [];
    if (errors.length > 0) {
      throw new Error("Inserted questions with errors");
    }

    return tagsData;
  };

  // Main function that orchestrates the process
  const handleSaveAndTagsInOneClick = async () => {
    // Show initial processing message
    setIsMessageBoxVisible(true);
    setNoTimeSet(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>Processing the file and saving...</span>
        </div>
      </div>
    );
    setActiveImg(SuccessImg);

    try {
      // Step 1: Handle bulk upload
           // Step 1: Handle bulk upload
      const saveData = await handleBulkUpload();

      // Check for errors in the response
      const errors = saveData.errors || [];
      const parseQuesSetId = saveData.result?.new_parse_ques_set_id;
      if (errors.length > 0) {
        // Prepare error content for TXT
        const errorContent = [
          `Parse Ques Set ID: ${parseQuesSetId}`,
          "Errors:",
          ...errors
        ].join("\n");
        showErrorMessage(
          "Some questions were inserted with errors. Please download and review the details.",
          "error_report.txt",
          errorContent
        );
        return;
      }

      // Step 2: Handle tags update
      await handleTagsUpdate(parseQuesSetId, saveData);

      // Keep showing processing message until reload
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Processing the file and saving tags... in Database. </span>
          </div>
        </div>
      );
      setActiveImg(SuccessImg);
      // Wait before reload
      await new Promise((resolve) => setTimeout(resolve, 2000));
      window.location.reload();
    } catch (error) {
      console.error("Error during the process:", error);
      if (
        error.message === "Unknown error" ||
        error.message?.toLowerCase().includes("unknown error")
      ) {
        showErrorMessage(
          "An unexpected error occurred. Please download and review the details.",
          "unknown_error.txt",
          `Error Details:\n${
            error.stack || error.message || JSON.stringify(error)
          }`
        );
      } else {
        showErrorMessage(
          error.message ||
            "An unexpected error occurred. Please try again later."
        );
      }
    }
  };
  // const handleSaveAndTagsInOneClick = async () => {
  //   // Initial validation
  //   if (!uploadedFile || !selectedSetName || !value.course_id) {
  //     let errorMessage = "";
  //     if (!uploadedFile && !selectedSetName && !value.course_id) {
  //       errorMessage =
  //         "No file uploaded, no set name selected, and no course selected. Please provide all required inputs.";
  //     } else if (!uploadedFile) {
  //       errorMessage =
  //         "No file uploaded. Please upload a file before proceeding.";
  //     } else if (!selectedSetName) {
  //       errorMessage =
  //         "No set name selected. Please select a set name before proceeding.";
  //     } else if (!value.course_id) {
  //       errorMessage =
  //         "No course selected. Please select a course before proceeding.";
  //     }

  //     showErrorMessage(errorMessage);
  //     return;
  //   }

  //   // Show initial processing message
  //   setIsMessageBoxVisible(true);
  //   setNoTimeSet(true);
  //   setMessageBox(
  //     <div className="Container-messageBOX">
  //       <div className="messagebox-insider1">
  //         <div className="loader-tc"></div>
  //         <span>Processing the file and saving...</span>
  //       </div>
  //     </div>
  //   );
  //   setActiveImg(null);

  //   try {
  //     // Check if set name already exists
  //     if (setNames.some((set) => set.id === selectedSetName?.id)) {
  //       showErrorMessage(
  //         `Set name already exists with ID: ${selectedSetName?.id}.`
  //       );
  //       return;
  //     }

  //     let parseQuesSetId = null;
  //     if (
  //       selectedSetName &&
  //       typeof selectedSetName === "object" &&
  //       selectedSetName.id
  //     ) {
  //       parseQuesSetId = selectedSetName.id;
  //     }

  //     // First API call - Save bulk questions
  //     const saveEndpoint = `${API_BASE_URL}/coaching-collaborator-api/api/v1/post-parse-question-bulk?parse_ques_set_name=${encodeURIComponent(
  //       typeof selectedSetName === "string"
  //         ? selectedSetName
  //         : selectedSetName.label
  //     )}&client_id=${clientId}&client_branch_id=${clientBranchId}&parse_ques_set_ques_type=1&username=${userName}${
  //       parseQuesSetId ? `&parse_ques_set_id=${parseQuesSetId}` : ""
  //     }`;

  //     const formData = new FormData();
  //     formData.append("selectedfile", uploadedFile);

  //     const saveResponse = await fetch(saveEndpoint, {
  //       method: "POST",
  //       headers: {
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //       body: formData,
  //     });

  //     const saveData = await saveResponse.json();

  //     if (!saveResponse.ok) {
  //       showErrorMessage(
  //         `Failed to save file: ${saveData.message || "Unknown error"}`,
  //         "save_error.txt",
  //         `Error Details:\n${JSON.stringify(saveData, null, 2)}`
  //       );
  //       return;
  //     }

  //     // Keep showing processing message
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>Processing the file and saving...</span>
  //         </div>
  //       </div>
  //     );

  //     // Second API call - Save tags
  //     parseQuesSetId = saveData.result.new_parse_ques_set_id;
  //     const selectedTags = prepareTags();
  //     const tagsEndpoint = `${API_BASE_URL}/coaching-collaborator-api/api/v1/insert-parse-ques-tags/?parse_ques_set_id=${parseQuesSetId}`;

  //     const tagsResponse = await fetch(tagsEndpoint, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //       body: JSON.stringify(selectedTags),
  //     });

  //     const tagsData = await tagsResponse.json();

  //     if (!tagsResponse.ok) {
  //       showErrorMessage(
  //         `Error saving tags: ${tagsData.message || "Unknown error"}`,
  //         "tags_error.txt",
  //         `Error Details:\n${JSON.stringify(tagsData, null, 2)}`
  //       );
  //       return;
  //     }

  //     // Handle any errors from bulk save
  //     const errors = saveData.errors || [];
  //     if (errors.length > 0) {
  //       showErrorMessage(
  //         "Inserted questions with errors. Please download and review the details.",
  //         "error_report.txt",
  //         errors.join("\n")
  //       );
  //       return;
  //     }

  //     // Keep showing processing message until reload
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>Processing the file and saving...</span>
  //         </div>
  //       </div>
  //     );

  //     // Wait before reload
  //     await new Promise((resolve) => setTimeout(resolve, 2000));
  //     window.location.reload();
  //   } catch (error) {
  //     console.error("Error during the process:", error);
  //     showErrorMessage("An unexpected error occurred. Please try again later.");
  //   }
  // };
  // const handleSaveAndTagsInOneClick = async () => {
  //   setNoTimeSet(false);
  //   if (!uploadedFile || !selectedSetName || !value.course_id) {
  //     console.error("Validation Error!");

  //     let errorMessage = "";
  //     if (!uploadedFile && !selectedSetName && !value.course_id) {
  //       errorMessage = "No file uploaded, no set name selected, and no course selected. Please provide all required inputs.";
  //     } else if (!uploadedFile) {
  //       errorMessage = "No file uploaded. Please upload a file before proceeding.";
  //     } else if (!selectedSetName) {
  //       errorMessage = "No set name selected. Please select a set name before proceeding.";
  //     } else if (!value.course_id) {
  //       errorMessage = "No course selected. Please select a course before proceeding.";
  //     }

  //     setIsMessageBoxVisible(true);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>{errorMessage}</span>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(InterogativeImg);
  //     return;
  //   }

  //   try {
  //     setIsMessageBoxVisible(true);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>Processing the file and saving...</span>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(null);

  //     let parseQuesSetId = null;

  //     if (selectedSetName && typeof selectedSetName === "object" && selectedSetName.id) {
  //       parseQuesSetId = selectedSetName.id;
  //     }

  //     const saveEndpoint = `${API_BASE_URL}/coaching-collaborator-api/api/v1/post-parse-question-bulk?parse_ques_set_name=${encodeURIComponent(
  //       typeof selectedSetName === "string" ? selectedSetName : selectedSetName.label
  //     )}&client_id=${clientId}&client_branch_id=${clientBranchId}&parse_ques_set_ques_type=1&username=${userName}${parseQuesSetId ? `&parse_ques_set_id=${parseQuesSetId}` : ""
  //       }`;

  //     const formData = new FormData();
  //     formData.append("selectedfile", uploadedFile);

  //     const saveResponse = await fetch(saveEndpoint, {
  //       method: "POST",
  //       headers: {
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //       body: formData,
  //     });

  //     const saveData = await saveResponse.json();

  //     if (!saveResponse.ok) {
  //       showErrorMessage(
  //         `Failed to save file: ${saveData.message || "Unknown error"}`,
  //         "save_error.txt",
  //         `Error Details:\n${JSON.stringify(saveData, null, 2)}`
  //       );
  //       return;
  //     }

  //     parseQuesSetId = saveData.result.new_parse_ques_set_id;

  //     const selectedTags = prepareTags();
  //     const tagsEndpoint = `${API_BASE_URL}/coaching-collaborator-api/api/v1/insert-parse-ques-tags/?parse_ques_set_id=${parseQuesSetId}`;

  //     const tagsResponse = await fetch(tagsEndpoint, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //       body: JSON.stringify(selectedTags),
  //     });

  //     if (setNames.some((set) => set.id === selectedSetName?.id)) {
  //       setIsMessageBoxVisible(true);
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc"></div>
  //             <span>
  //               Set name already exists with ID: {selectedSetName?.id}.
  //             </span>
  //           </div>
  //         </div>
  //       );
  //       setActiveImg(InterogativeImg);
  //       return;
  //     }

  //     const errors = saveData.errors || [];
  //     const successMessage = saveData.result.message || "Operation completed successfully.";

  //     if (errors.length > 0) {
  //       showErrorMessage(
  //         "Inserted questions with errors. Please download and review the details.",
  //         "error_report.txt",
  //         errors.join("\n")
  //       );
  //     } else {
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc"></div>
  //             <span>{successMessage}</span>
  //           </div>
  //         </div>
  //       );
  //       setActiveImg(SuccessImg);
  //       setTimeout(() => {
  //         window.location.reload();
  //       }, 2000);
  //     }
  //   } catch (error) {
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>An unexpected error occurred. Please try again later.</span>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(InterogativeImg);
  //   }
  // };

  return (
    <div className="create-role-container">
      <div className="create-role-container-tagging">
        <span className="create-role-heading">Parse Question File</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={() => navigate(-1)}>
            CANCEL
          </button>
          <button
            className="cr-create-btn"
            onClick={handleSaveAndTagsInOneClick}
            style={{ backgroundColor: "#424342", color: "white" }}
          >
            SAVE
          </button>
        </div>
      </div>
      {/* QUESTION TAGGING Section */}
      <div className="parse-tagging">
        <div className="personal-header">
          <div className="header">
            <h2>QUESTION TAGGING</h2>
          </div>
          <div className="accordion-btn" onClick={toggleTaggingAccordion}>
            {isOpenTagging ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpenTagging && (
          <div className="accordion-content-tagging-container">
            <div className="grid-container-tagging">
              <div className="grid-item">
                <AddOptionDropdwon
                  label="Set Name"
                  placeholder="Type or select Set Name"
                  setSelected={(selectedOption) => {
                    if (selectedOption) {
                      setSelectedSetName(selectedOption);
                    }
                  }}
                  options={setNames}
                  setOptions={setSetNames}
                  isRequired={true}
                  Height="auto"
                  OverFlow="auto"
                  minheight="300px"
                />
              </div>
              <div className="grid-item">
                <DropDown
                  label="Course"
                  setSelected={(selectedOption) => {
                    setValues({ ...value, course_id: selectedOption });
                    setDropdownKey(Date.now());
                  }}
                  options={
                    coursesdata
                      ? coursesdata.map((course) => ({
                          label: course.course_description,
                          id: course.course_id,
                        }))
                      : []
                  }
                  isRequired={true}
                />
              </div>
              <div className="grid-item">
                <DropDownUP
                  label="Subject"
                  setSelected={setSelectedSubject}
                  selectedLabel={selectedSubjectLabel}
                  setSelectedLabel={setSelectedSubjectLabel}
                  options={subjects.map((subject) => ({
                    label: subject.subject_name,
                    id: subject.subject_id,
                  }))}
                  isRequired={true} // Add this line
                />
              </div>
              <div className="grid-item">
                <DropDownUP
                  label="Chapter"
                  setSelected={setSelectedChapter}
                  selectedLabel={selectedChapterLabel}
                  setSelectedLabel={setSelectedChapterLabel}
                  options={chapters.map((chapter) => ({
                    label: chapter.chapter_name,
                    id: chapter.chapter_id,
                  }))}
                />
              </div>
              <div className="grid-item">
                <DropDownUP2
                  label="Topic"
                  setSelected={setTopicId}
                  selectedLabel={selectedTopicLabel}
                  setSelectedLabel={setSelectedTopicLabel}
                  options={topics.map((topic) => ({
                    label: topic.topic_name,
                    id: topic.topic_id,
                  }))}
                />
              </div>
              {/* Dropdowns */}
              {tags
                .filter((tag) => tag.parse_tag_type === 1)
                .map((tag) => (
                  <div className="grid-item" key={tag.parse_tag_id}>
                    <DropDown
                      label={tag.parse_tag_name}
                      setSelected={(selectedOption) =>
                        handleDropdownChange(tag, selectedOption)
                      }
                      options={tag.parse_tag_value.map((value) => ({
                        label: value.tag_value,
                        id: value.parse_tag_value_id,
                      }))}
                    />
                  </div>
                ))}
            </div>
            <div className="grid-container-tagging">
              {/* Checkboxes */}
              {tags
                .filter((tag) => tag.parse_tag_type === 2)
                .map((tag) => (
                  <div className="grid-item" key={tag.parse_tag_id}>
                    <div className="check-box-tag-impt">
                      <input
                        type="checkbox"
                        id={`checkbox-${tag.parse_tag_id}`}
                        className="cr-custom-checkbox-tags"
                      />
                      <label htmlFor={`checkbox-${tag.parse_tag_id}`}>
                        {tag.parse_tag_name}
                      </label>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
      {/* UPLOAD FILE Section */}
      <div className="parse-tagging">
        <div className="personal-header">
          <div className="header">
            <h2>UPLOAD FILE</h2>
          </div>
          <div className="accordion-btn" onClick={toggleUploadAccordion}>
            {isOpenUpload ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpenUpload && (
          <div className="accordion-content-tagging-container">
            <div className="grid-container-upload-file">
              <FileUpload label="Select File" onFileSelect={handleFileUpload} />
              <div className="file-upload-instructions">
                <p>
                  <strong>Instructions for Uploading:</strong>
                </p>
                <p>
                  1. Ensure the file format is <strong>.docx</strong> or{" "}
                  <strong>.doc</strong>. Other formats, including PDFs, are not
                  supported.
                </p>
                <p>
                  2. Do not include blank spaces in the file name. Use
                  underscores (_) or hyphens (-) instead.
                </p>
                {/* <p>3. Ensure the content of the file is free from any confidential or sensitive information unless authorized.</p> */}
                <p>
                  3. Question numbering format: Use hash (#) before the number
                  and dot (.) after the number. Example - #1., #11., #111.
                </p>
                <p>
                  4. Always keep one space after the dot (.) in question
                  numbering.
                </p>
                <p>
                  5. Option numbering format: Use (@) before the number and
                  enclose it in brackets (). Example - (@1), (@2). Mark correct
                  answers with an asterisk (*). Example - (@*1), (@*4).
                </p>
                <p>6. Do not use alphabets like (a, b, c, d) for options.</p>
                <p>
                  7. Do not use subscript or superscript formatting (e.g., A
                  <sub>2</sub> or A<sup>2</sup> is not allowed). Instead, use
                  the insert equation feature. Example: A=πr^2.
                </p>
                <p>
                  8. Adding images/pictures: .emf format is not supported. Use
                  .png or .jpg formats. Use online converters to convert images
                  to these formats if necessary.
                </p>
                <p>
                  9. Always keep one blank line between questions and options.
                </p>
                <p>
                  10. Word limit on Solution is{" "}
                  <span style={{ fontWeight: "bold" }}> 5000</span> characters.
                </p>
                {/* <p>11. Save the file as a <strong>.docx</strong> or <strong>.doc</strong>. PDFs are not supported.</p>
                <p>12. Do not include blank spaces in the file name.</p> */}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ParseBulkQuestion;

// const [signedUrl, setSignedUrl] = useState(null);

//   useEffect(() => {
//     // Fetch the signed URL from your backend or function
//     const fetchSignedUrl = async () => {
//       try {
//         // Replace with the actual API endpoint or function to get the signed URL
//         const response = await fetch('http://127.0.0.1:8000/coaching-collaborator-api/api/v1/get-signed-url/'); // Example backend URL
//         const data = await response.json();
//         setSignedUrl(data);
//       } catch (error) {
//         console.error('Error fetching signed URL:', error);
//       }
//     };

//     fetchSignedUrl();
//   }, []);

//   return (
//     <div>
//       {signedUrl ? (
//         <img src={signedUrl} alt="S3 Object" style={{ maxWidth: '100%', height: 'auto' }} />
//       ) : (
//         <p>Loading image...</p>
//       )}
//     </div>
//   );
